import {LoggedInUser, UnauthenticatedUser} from "./user-context"
import {throwOnErrorWithMessage} from "../api/api-utils"

export interface IAuthenticationService {
  loadUser(signal?: AbortSignal): Promise<void>
  signIn(email: string, password: string, signal?: AbortSignal): Promise<void>
  signOut(signal?: AbortSignal): Promise<void>
}

export class AuthenticationService implements IAuthenticationService {
  constructor(private baseUrl: string, private onUserChanged: (user: LoggedInUser) => void) {
  }

  async loadUser(signal?: AbortSignal): Promise<void> {
    const url = this.baseUrl + "/authentication/user"
    const response = await fetch(url, {method: "get", signal, credentials: "include"})
    if (!response.ok) throw new Error("Error occurred when loading user")
    const user = (response.status === 200)
      ? AuthenticationService.getLoggedInUser(await response.json())
      : UnauthenticatedUser
    this.onUserChanged(user)
  }

  private static getLoggedInUser(originalUser: LoggedInUser): LoggedInUser {
    if (originalUser == null) return UnauthenticatedUser
    return new LoggedInUser(originalUser.id, originalUser.name, originalUser.email)
  }

  async signIn(email: string, password: string, signal?: AbortSignal): Promise<void> {
    const url = this.baseUrl + "/authentication/signIn"
    const authenticationUser = {email, password}
    const response = await fetch(url, {method: "post", body: JSON.stringify(authenticationUser), headers: {"Content-Type": "application/json"}, signal, credentials: "include"})
    await throwOnErrorWithMessage(response)
    await this.loadUser()
  }

  async signOut(signal?: AbortSignal): Promise<void> {
    const url = this.baseUrl + "/authentication/signOut"
    const response = await fetch(url, {method: "get", signal, credentials: "include"})
    if (!response.ok) throw new Error("Error occurred when signing out")
    await this.loadUser()
  }
}
